import { render } from "./DeliveryActions.vue?vue&type=template&id=c34c5a1c&scoped=true"
import script from "./DeliveryActions.vue?vue&type=script&lang=js"
export * from "./DeliveryActions.vue?vue&type=script&lang=js"

import "./DeliveryActions.vue?vue&type=style&index=0&id=c34c5a1c&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c34c5a1c"]])

export default __exports__